import { Titles } from '@bb/users';
import type { CachedOnboardingPortal } from '@bb/automaton';

const TITLE_MAP: Record<
  Titles,
  (portalConfig?: Pick<CachedOnboardingPortal, 'overrideLabel'>) => string
> = {
  [Titles.Administrator]: () => Titles.Administrator,
  [Titles.Salesperson]: () => Titles.Salesperson,
  [Titles.Broker]: () => Titles.Broker,
  [Titles['Broker of Record']]: (
    config?: Pick<CachedOnboardingPortal, 'overrideLabel'>,
  ) => config?.overrideLabel || Titles['Broker of Record'],
};

const getUserTitle = (
  title: Titles,
  portalConfig?: Pick<CachedOnboardingPortal, 'overrideLabel'>,
): string => TITLE_MAP[title](portalConfig);

const buildUserTitles = (
  portalConfig?: Pick<CachedOnboardingPortal, 'overrideLabel'>,
  titles: Titles[] = Object.values(Titles),
) =>
  titles.reduce<Record<Titles, { label: string; value: Titles }>>(
    (acc, title) => {
      acc[title] = { label: getUserTitle(title, portalConfig), value: title };
      return acc;
    },
    {
      [Titles.Administrator]: {
        label: Titles.Administrator,
        value: Titles.Administrator,
      },
      [Titles.Salesperson]: {
        label: Titles.Salesperson,
        value: Titles.Salesperson,
      },
      [Titles.Broker]: { label: Titles.Broker, value: Titles.Broker },
      [Titles['Broker of Record']]: {
        label: Titles['Broker of Record'],
        value: Titles['Broker of Record'],
      },
    },
  );

export { getUserTitle, buildUserTitles };
